import { createFileRoute } from '@tanstack/react-router';
import StructureMapPage from '../../components/analysis/StructureMapPage';

export const Route = createFileRoute('/analysis/')({
  component: StructureMapPage,
});
